import { Component, inject } from '@angular/core';
import { SoilUseGroupService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SoilUseGroupCreateDto,
  SoilUseGroupDto,
  SoilUseGroupExcelDownloadDto,
  SoilUseGroupUpdateDto,
} from '../proxy/planning/dtos/soil-use-group';
import { SOILUSEGROUP_CONFIG, SOILUSEGROUP_FIELDS } from './soil-use-group.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-soil-use-group',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SoilUseGroupService, ConfirmationService],
  templateUrl: './soil-use-group.html',
  styleUrl: './soil-use-group.scss',
})
export class SoilUseGroup extends BaseCrudComponent<
  SoilUseGroupDto,
  SoilUseGroupCreateDto,
  SoilUseGroupUpdateDto,
  SoilUseGroupExcelDownloadDto
> {
  service = inject(SoilUseGroupService);
  config = SOILUSEGROUP_CONFIG;
  fields = SOILUSEGROUP_FIELDS;

  protected prepareUpdateDto(data: any, selected: SoilUseGroupDto): SoilUseGroupUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SoilUseGroup';
  }
}
